import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import titleize from 'underscore.string/titleize'

import LineItem from 'desktop/components/checkout/line_item'
import BundleTracker from 'desktop/components/layout/bundle_tracker'

import { getTitleForBundledItems } from 'base/lib/bundling'
import {
  getShippableLineItems,
  getLineItemsShippingLater,
  getVirtualLineItems,
} from 'base/reducers/cart'

// TODO: This component could use some TLC
class Cart extends Component {
  static propTypes = {
    imageHeight: PropTypes.number,
    maxHeight: PropTypes.number,
    lineItems: PropTypes.array,
    changeLineItemQuantity: PropTypes.func.isRequired,
    currentShippingOption: PropTypes.object,
    ignoreShipping: PropTypes.bool,
    isSyncing: PropTypes.bool,
    showDeliveryEstimates: PropTypes.bool,
    onTrackRemoveProduct: PropTypes.func.isRequired,
    showBundles: PropTypes.bool,
    isFlyoutCart: PropTypes.bool,
    title: PropTypes.string,
  }

  static defaultProps = {
    imageHeight: 150,
    showDeliveryEstimates: false,
  }

  getBundles = () => {
    return Object.values(
      this.props.lineItems.reduce((bundles, lineItem) => {
        const bundle = lineItem.bundle
        if (bundle) {
          const existingItems = bundles[bundle.id] || []
          return {
            ...bundles,
            [bundle.id]: [...existingItems, lineItem],
          }
        } else {
          return bundles
        }
      }, {}),
    )
  }

  // Event Handlers

  handleIncrementQuantity = id => {
    const lineItem = this.props.lineItems.find(li => li.id === id)

    this.props.changeLineItemQuantity(lineItem, lineItem.quantity + 1)
  }

  handleDecrementQuantity = id => {
    const lineItem = this.props.lineItems.find(li => li.id === id)

    if (lineItem.quantity - 1 === 0) {
      this.props.onTrackRemoveProduct(lineItem)
    }

    this.props.changeLineItemQuantity(lineItem, lineItem.quantity - 1)
  }

  handleRemove = id => {
    const lineItem = this.props.lineItems.find(li => li.id === id)

    this.props.onTrackRemoveProduct(lineItem)

    this.props.changeLineItemQuantity(lineItem, 0)
  }

  // Rendering

  renderAllLineItems = () => {
    const hasBundles = this.props.showBundles && this.getBundles().length > 0
    const unbundledItems = this.props.lineItems.filter(item => {
      if (this.props.showBundles) {
        return !item.bundle
      } else {
        return true
      }
    })

    if (!unbundledItems.length) return null

    return (
      <div className="cart__group">
        {hasBundles && unbundledItems.length > 0 && (
          <div className="cart__group-title">Other Items</div>
        )}

        {unbundledItems.map(lineItem => {
          return (
            <LineItem
              isFlyoutCart={this.props.isFlyoutCart}
              lineItem={lineItem}
              imageHeight={this.props.imageHeight}
              key={lineItem.id}
              onIncrementQuantity={this.handleIncrementQuantity}
              onDecrementQuantity={this.handleDecrementQuantity}
              onRemove={this.handleRemove}
              isSyncing={this.props.isSyncing}
            />
          )
        })}
      </div>
    )
  }

  renderLineItemsForBundles = () => {
    const bundledLineItems = this.getBundles()

    return bundledLineItems.map(lineItems => {
      const firstLineItem = lineItems[0]
      const bundleInfo = firstLineItem.bundle
      const title = getTitleForBundledItems(lineItems)

      const totalTowardsBundle = lineItems.reduce((total, lineItem) => total + lineItem.quantity, 0)

      return (
        <div className="cart__group" key={bundleInfo.id}>
          <BundleTracker
            title={title}
            bundle={bundleInfo}
            currencySymbol={firstLineItem.currency_symbol}
            originalPrice={firstLineItem.price}
            lineItemCount={totalTowardsBundle}
          />

          {lineItems.map(lineItem => {
            return (
              <LineItem
                isFlyoutCart={this.props.isFlyoutCart}
                lineItem={lineItem}
                imageHeight={this.props.imageHeight}
                key={lineItem.id}
                onIncrementQuantity={this.handleIncrementQuantity}
                onDecrementQuantity={this.handleDecrementQuantity}
                onRemove={this.handleRemove}
                isSyncing={this.props.isSyncing}
              />
            )
          })}
        </div>
      )
    })
  }

  renderLineItemsShippingNow = () => {
    const lineItems = this.props.shippableLineItems.map(lineItem => {
      return (
        <LineItem
          isFlyoutCart={this.props.isFlyoutCart}
          lineItem={lineItem}
          imageHeight={this.props.imageHeight}
          key={lineItem.id}
          onIncrementQuantity={this.handleIncrementQuantity}
          onDecrementQuantity={this.handleDecrementQuantity}
          onRemove={this.handleRemove}
          isSyncing={this.props.isSyncing}
        />
      )
    })

    if (!lineItems.length) return null

    return (
      <div className="new-checkout__cart-list-section">
        <h3 className="new-checkout__cart-list-section-title">Shipping Soon</h3>
        {lineItems}
      </div>
    )
  }

  renderLineItemsShippingLater = () => {
    const lineItems = this.props.shippingLaterLineItems.map(lineItem => {
      return (
        <LineItem
          isFlyoutCart={this.props.isFlyoutCart}
          lineItem={lineItem}
          imageHeight={this.props.imageHeight}
          key={lineItem.id}
          onIncrementQuantity={this.handleIncrementQuantity}
          onDecrementQuantity={this.handleDecrementQuantity}
          onRemove={this.handleRemove}
          isSyncing={this.props.isSyncing}
        />
      )
    })

    if (!lineItems.length) return null

    const headerClassName = classNames('new-checkout__cart-list-section-title', {
      'new-checkout__cart-list-section-title--flyout-cart': this.props.isFlyoutCart,
    })

    return (
      <div className="new-checkout__cart-list-section">
        <h3 className={headerClassName}>Shipping Later</h3>
        {lineItems}
      </div>
    )
  }

  renderVirtualLineItems = () => {
    const lineItems = this.props.virtualLineItems.map(lineItem => {
      return (
        <LineItem
          isFlyoutCart={this.props.isFlyoutCart}
          lineItem={lineItem}
          imageHeight={this.props.imageHeight}
          key={lineItem.id}
          onIncrementQuantity={this.handleIncrementQuantity}
          onDecrementQuantity={this.handleDecrementQuantity}
          onRemove={this.handleRemove}
          isSyncing={this.props.isSyncing}
        />
      )
    })

    if (!lineItems.length) return null

    const headerClassName = classNames('new-checkout__cart-list-section-title', {
      'new-checkout__cart-list-section-title--flyout-cart': this.props.isFlyoutCart,
    })

    return (
      <div className="new-checkout__cart-list-section">
        <h3 className={headerClassName}>Digital</h3>
        {lineItems}
      </div>
    )
  }

  renderTitleForCurrentShippingOption = () => {
    if (this.props.title) {
      return this.props.title
    }

    if (this.props.currentShippingOption?.description) {
      return `${titleize(this.props.currentShippingOption.description)} ${
        this.props.currentShippingOption.details
      }`
    }

    return ''
  }

  renderLineItemsForCurrentShippingOption = () => {
    const lineItems = this.props.shippableLineItems.map(lineItem => {
      return (
        <LineItem
          isFlyoutCart={this.props.isFlyoutCart}
          lineItem={lineItem}
          imageHeight={this.props.imageHeight}
          key={lineItem.id}
          onIncrementQuantity={this.handleIncrementQuantity}
          onDecrementQuantity={this.handleDecrementQuantity}
          onRemove={this.handleRemove}
          isSyncing={this.props.isSyncing}
        />
      )
    })

    if (!lineItems.length) return null

    return (
      <div className="new-checkout__cart-list-section">
        <h3 className="new-checkout__cart-list-section-title">
          {this.renderTitleForCurrentShippingOption()}
        </h3>
        {lineItems}
      </div>
    )
  }

  render() {
    if (this.props.lineItems.length === 0) {
      return (
        <h4
          style={{
            fontSize: 13,
            textAlign: 'center',
            marginTop: 25,
            marginBottom: 40,
          }}
        >
          You have no items in your bag.
        </h4>
      )
    }

    if (this.props.ignoreShipping) {
      return (
        <div
          className={classNames('new-checkout__cart-list', {
            'flyout-cart__cart-list': this.props.isFlyoutCart,
          })}
          style={{ maxHeight: this.props.maxHeight }}
        >
          <div className="new-checkout__cart-slider">
            {this.props.showBundles && this.renderLineItemsForBundles()}
            {this.renderAllLineItems()}
          </div>
        </div>
      )
    }

    return (
      <div
        className={classNames('new-checkout__cart-list', {
          'flyout-cart__cart-list': this.props.isFlyoutCart,
        })}
        style={{ maxHeight: this.props.maxHeight }}
      >
        {this.renderLineItemsForCurrentShippingOption()}
        {this.renderLineItemsShippingLater()}
        {this.renderVirtualLineItems()}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    virtualLineItems: getVirtualLineItems(state.cart),
    shippingLaterLineItems: getLineItemsShippingLater(state.cart),
    shippableLineItems: getShippableLineItems(state.cart),
    lineItems: state.cart.line_items || [],
  }
}

export default connect(mapStateToProps)(Cart)
